module.exports = __webpack_public_path__ + "img/rightarw.d620323b.svg";